export default __webpack_public_path__ + "static/media/Colorizing_black_and_white_images.b58777ad.pdf";